import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Modal, ModalBody, Button } from "reactstrap";
import { TweenMax, Power2 } from "gsap";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import assetPath from "~/utils/assetPath";

import styles from "./styles.scss";

class ModalComponent extends React.Component {
  static propTypes = {
    onRef: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    toggleable: PropTypes.bool,
    onShowModal: PropTypes.func,
    onHideModal: PropTypes.func
  };

  static defaultProps = {
    className: "",
    toggleable: true
  };

  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
      isAnimating: false
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentWillMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidUpdate() {
    // Center container
    if (is.under($(`.${this.props.className} .modal-content`).outerHeight(), $(window).height())) {
      $(`.${this.props.className} .modal-content`).css({
        top: `${$(window).height() / 2 -
          $(`.${this.props.className} .modal-content`).outerHeight(true) / 2}px`
      });
    } else {
      $(`.${this.props.className} .modal-content`).css({
        top: `initial`
      });
    }

    // Update scrollbar
    _.delay(() => {
      $(".modal_wrapper .modal-dialog").perfectScrollbar("update");
    }, 0)
  }

  //-----------------------------------------------------------------------
  // Handlers
  //-----------------------------------------------------------------------
  handleToggle() {
    // Return if animating
    if (is.truthy(this.state.isAnimating)) {
      return;
    }

    // Show or hide modal
    if (is.truthy(this.state.isActive)) {
      this.hideModal();
    } else {
      this.showModal();
    }
  }

  showModal() {
    // Return if animating
    if (is.truthy(this.state.isAnimating)) {
      return;
    }

    // Set as not animating
    this.state.isAnimating = true;

    // Render modal
    this.setState({ isActive: true });

    // Wait until render
    setTimeout(() => {
      // Fade in modal
      TweenMax.to(".modal_wrapper", 160 / 1000, {
        opacity: 1,
        ease: Power2.easeInOut,
        onStart: () => {
          emitter.emit("modalDidShow");

          // Call on show modal
          if (is.existy(this.props.onShowModal)) {
            this.props.onShowModal();
          }

          // Center container
          if (is.under($(`.${this.props.className} .modal-content`).outerHeight(), $(window).height())) {
            $(`.${this.props.className} .modal-content`).css({
              top: `${$(window).height() / 2 -
                $(`.${this.props.className} .modal-content`).outerHeight(true) / 2}px`
            });
          }
        },
        onComplete: () => {
          // Initialize scrollbar
          $(".modal_wrapper .modal-dialog").perfectScrollbar({
            suppressScrollX: true
          });

          // Listen for click
          $(".modal").click((event) => {
            if (is.falsy($(event.target).hasClass("modal-body")) && is.equal($(event.target).parents(".modal-body").length, 0)) {
              this.hideModal();
            }
          });

          // Set as not animating
          this.state.isAnimating = false;
        }
      });
    }, 0);
  }

  hideModal() {
    // Return if animating
    if (is.truthy(this.state.isAnimating)) {
      return;
    }

    // Fade out modal
    TweenMax.to(".modal_wrapper", 160 / 1000, {
      opacity: 0,
      ease: Power2.easeInOut,
      onStart: () => {
        // Destroy scrollbar
        $(".modal_wrapper .modal-dialog").perfectScrollbar("destroy");

        // Set as not animating
        this.state.isAnimating = true;

        // Call on show modal
        if (is.existy(this.props.onHideModal)) {
          this.props.onHideModal();
        }
      },
      onComplete: () => {
        emitter.emit("modalDidHide");

        // Render modal
        this.setState({ isActive: false });

        // Set as not animating
        this.state.isAnimating = false;
      }
    });
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div className="modal_component" id="modal_component">
        <Modal
          isOpen={this.state.isActive}
          toggle={this.handleToggle}
          backdrop={is.truthy(this.props.toggleable) ? true : "static"}
          size="lg"
          zIndex="5000"
          className={this.props.className}
          wrapClassName="modal_wrapper"
        >
          <Container>
            <Row>
              <Col>
                <ModalBody>
                  <If condition={is.truthy(this.props.toggleable)}>
                    <Button
                      className="modal-close"
                      style={{
                        backgroundImage: `url(${assetPath("close", "png")})`
                      }}
                      onClick={this.hideModal}
                    />
                  </If>
                  {this.props.children}
                </ModalBody>
              </Col>
            </Row>
          </Container>
        </Modal>
      </div>
    );
  }
}

export default withStyles(styles)(ModalComponent);



// WEBPACK FOOTER //
// ./src/components/ModalComponent/index.js